/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// libraries
import React from 'react';
import {
    string, shape, bool,
} from 'prop-types';
import { useQuery } from '@apollo/client';
import mbpLogger from 'mbp-logger';
import { GRAPHQL_ENV } from '../../../../../../gql';
import PDPDeliveryButton from '../PDPDeliveryButton';
import findContent from '../../../../../../gql/queries/findContent';

const PDPDeliveryPopupContainer = ({
    brand, productDeliveryType, pageType, isPDPCalendarPopupEnabled, isROSSPassport, isPdpRedesignEnabled, showProductTitleTop, isPlaRedesignEnabled, productBrand,
}) => {
    if (!isPDPCalendarPopupEnabled) {
        return null;
    }

    const contentType = 'design_and_delivery_details';
    const DELIVERY_POPUP_QUERY = findContent({
        brand: brand.domain,
        contentType,
        query: `\\"title\\" : \\"${productDeliveryType}\\"`,
    });

    const { data, loading, error } = useQuery(DELIVERY_POPUP_QUERY);

    if (loading) {
        return null;
    }
    if (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            query: DELIVERY_POPUP_QUERY,
            jsError: error,
            component: 'PDPDeliveryPopupContainer.js',
            message: `Failed to fetch content data for: content type ${contentType} on brand ${brand}`,
            env: GRAPHQL_ENV,
        });
    }
    if (!data) {
        return null;
    }

    return (
        <PDPDeliveryButton data={data} pageType={pageType} isROSSPassport={isROSSPassport} isPdpRedesignEnabled={isPdpRedesignEnabled} productDeliveryType={productDeliveryType} showProductTitleTop={showProductTitleTop} isPlaRedesignEnabled={isPlaRedesignEnabled} brand={brand} productBrand={productBrand} />
    );
};
PDPDeliveryPopupContainer.propTypes = {
    brand: shape({
        domain: string,
    }).isRequired,
    pageType: string,
    productDeliveryType: string.isRequired,
    isPDPCalendarPopupEnabled: bool.isRequired,
    isROSSPassport: bool,
    isPdpRedesignEnabled: bool,
    showProductTitleTop: bool,
    isPlaRedesignEnabled: bool,
    productBrand: string,
};

PDPDeliveryPopupContainer.defaultProps = {
    pageType: '',
    isROSSPassport: false,
    isPdpRedesignEnabled: false,
    showProductTitleTop: false,
    isPlaRedesignEnabled: false,
    productBrand: '',
};

export default PDPDeliveryPopupContainer;
